var map = {
	"./categories-01.jpg": 38065,
	"./categories-02.jpg": 96646,
	"./categories-03.jpg": 61347,
	"./categories-04.jpg": 46544,
	"./categories-05.jpg": 89997,
	"./categories-06.jpg": 41506,
	"./categories-07.jpg": 61503,
	"./categories-08.jpg": 33756,
	"./categories-09.jpg": 31129,
	"./categories-10.jpg": 67635,
	"./categories-11.jpg": 12374,
	"./categories-12.jpg": 45633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54085;